import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useSnackbar } from '@context/SnackbarContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

interface UseConsumeLoyaltyRewardParams {
  onComplete?: () => void
}

interface UseConsumeLoyaltyRewardValue {
  consumeLoyaltyReward: (reward: {
    rewardId: string
    rewardTierLabel?: string | null
  }) => Promise<void>
  isLoading: boolean
}

export const useConsumeLoyaltyReward = ({
  onComplete,
}: UseConsumeLoyaltyRewardParams = {}): UseConsumeLoyaltyRewardValue => {
  const apiClient = useApiClient(ClientApiClient)
  const { addSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const [isLoading, setIsLoading] = useState(false)

  const consumeLoyaltyReward = async (reward: {
    rewardId: string
    rewardTierLabel?: string | null
  }) => {
    setIsLoading(true)

    await apiClient.consumeLoyaltyReward(reward?.rewardId)

    addSnackbar.success({
      message: reward.rewardTierLabel
        ? t('IB.Your reward for the {{levelTitle}} was successfully redeemed', {
            levelTitle: reward.rewardTierLabel,
          })
        : t('IB.Your reward was successfully redeemed'),
    })

    onComplete?.()

    setIsLoading(false)
  }

  return {
    consumeLoyaltyReward,
    isLoading,
  }
}
